import {rgbColorToHexString} from '@shared_web/theme/color_convertions';
import {RgbColor} from '@shared_web/theme/color_models';

const rgbConvert = (v: number): number => {
  return v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
};
export function luminance(rgb: RgbColor): number {
  const r = rgbConvert(rgb.r);
  const g = rgbConvert(rgb.g);
  const b = rgbConvert(rgb.b);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

const grayScale = [...new Array(256)].map((_, i) => {
  const gray = i / 255;
  const rgb = {r: gray, g: gray, b: gray, a: 1};
  return {
    hex: rgbColorToHexString(rgb),
    lum: luminance(rgb),
  };
});

const luminanceContrast = (l1: number, l2: number): number => {
  return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
};

// Return the color that has the highest contrast when displayed over the `backgroundColor`
export function textColorForContrast(backgroundColor: RgbColor, contrast: number): string {
  const lum = luminance(backgroundColor);

  let bestGray: {hex: string; lum: number; c: number} | undefined;
  for (const gray of grayScale) {
    const c = luminanceContrast(gray.lum, lum);
    // No curent best
    if (!bestGray) {
      bestGray = {...gray, c};
    }
    // Valid contrast
    else if (c >= contrast) {
      // Current best is valid but current contrast closer to target than current best
      if (bestGray.c >= contrast && bestGray.c - contrast > c - contrast) {
        bestGray = {...gray, c};
      }
      // Current best is not valid
      else if (bestGray.c < contrast) {
        bestGray = {...gray, c};
      }
    }
    // Non-valid contrast, but still better than current best which is also non-valid
    else if (bestGray.c < contrast && c > bestGray.c) {
      bestGray = {...gray, c};
    }
  }

  return bestGray?.hex ?? '#000000';
}
